/**
 * Service-worker registration (Phase 9 PR 12a; spec §10 lines 1530, 1537).
 * Registers the app-shell service worker so HapMetrix is installable and opens
 * offline on iOS Safari, Android Chrome, macOS and Windows.
 *
 * Registered only in production builds (the SW is emitted to the served root);
 * the Vite dev server uses HMR/inline scripts and must not be intercepted.
 * Foreground sync only - the worker never owns Background Sync (§10 line 1540).
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Registration failure must never break the app - it just means no
      // offline shell this session.
    });
  });
}
